import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var LocalStorageService = function LocalStorageService() {
  _classCallCheck(this, LocalStorageService);

  this.set = function (name, value) {
    localStorage.setItem(name, value);
  };

  this.get = function (name) {
    return localStorage.getItem(name);
  };

  this.removeItem = function (name) {
    return localStorage.removeItem(name);
  };
};

export default new LocalStorageService();